import * as React from 'react';
import { getFocusableChildren, bindKeypress } from '../../helpers/window-helpers';
import Modal, { IModalProps } from '../../common/modal/modal';
import VenueLevelListFilter from '../../filter/components/venue-level-filter';
import { Level } from '../../classes/level';
import { IAppSettingsModel } from '../../reducers/fetch-settings-reducer';
import { unselectSeat, selectVenueLevel } from '../actions/seatmap-actions';
import { CartSeat } from '../../classes/seat';

export interface ILevelSelectionModalProps extends IModalProps {
    currentSeatmapId: string;
    venueLevels: Array<Level>;
    dispatch: any;
    selectedPriceTypeIdsString: string;
    appSettings: IAppSettingsModel;
    cartSeats: Array<CartSeat>;
    levelHeading: string;
}

class LevelSelectionModal extends Modal<ILevelSelectionModalProps> {
    constructor(props) {
        super(props);
    }

    renderModalContent() {
        const useTagClose = '<use xlink:href="#icon-close" />';

        return (
            <section role="dialog" aria-labelledby="modal-title" className="modal-container" id="modal-container">
                <div role="document">

                    <div className="modal-content">
                        <div>
                            <svg className="seat-info-views-icon" onClick={this._onCloseModal.bind(this)} dangerouslySetInnerHTML={{ __html: useTagClose }} />
                        </div>
                        <VenueLevelListFilter levels={this.props.venueLevels}
                            {...this.props.appSettings}
                            levelsHeading={this.props.levelHeading}
                            clearButton=""
                            dispatch={this.props.dispatch}
                            onSelectLevel={this._onSelectVenueLevel}
                            onResetLevels={this._onResetVenueLevel}
                            selectedLevelString={this.props.currentSeatmapId.length > 0
                                ? this.props.venueLevels.filter(lvl => lvl.seatmap.id === this.props.currentSeatmapId)[0].levelNumber.toString()
                                : ""}
                            selectedPriceTypeIdsString={this.props.selectedPriceTypeIdsString}
                            showComponent={true}
                            isCheckbox={false}
                        />
                    </div>
                </div>
            </section>
        );
    }

    _onCloseModal = () => {
        this.props.closeFunction();
    }

    _onSelectVenueLevel = (level: Level) => {
        this.props.dispatch(unselectSeat());
        this.props.dispatch(selectVenueLevel(level, this.props.cartSeats));
    }
    _onResetVenueLevel() {
    }
}

export default LevelSelectionModal;